module.exports = __webpack_public_path__ + "img/suriname.ba3c45c0.svg";